import React, { Component, useState } from 'react';
import '../AI_AssistedResumeBuilder/Ai_add_resume.css';
import axios from 'axios';
import { endpoint } from '../../../resource/Constant';
import { useNavigate } from 'react-router-dom';
import { Backdrop, CircularProgress } from '@mui/material';
import DragSwapBoxes from './AI_Assisted_Resume_Builder_usingdnd';

const AI_Add_Resume = () => {
  const [position, setPosition] = useState('');
  const [industry, setIndustry] = useState('');
  const [experience, setExperience] = useState('');
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const handleOnClick = () => {
    setPosition('');
    setIndustry('');
    setExperience('');
    setLoader(true);
    axios
      .post(
        `${endpoint}/api/aichatbot/resume/generate`,
        {
          years_of_experience: experience,
          job_role: position,
          industry: industry
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` } }
      )
      .then((res) => {
        setLoader(false);
        const summary = res.data['summary'];
        const work_history = res.data['work_history'];
        const education = res.data['education'];
        const skills = res.data['skills'];
        navigate('/aichatbot/dashboard/aigeneratedresume', {
          state: { componentProps: { summary: summary, work_history: work_history, education: education, skills: skills } }
        });
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  return (
    <>
      <div className="" style={{ minHeight: '90vh' }}>
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="text-center mb-5">
              <h3 className="display-5 gradient-text mb-3" style={{ fontFamily: 'Work Sans, Lora, Merriweather' }}>
                AI-Powered Resume Builder
              </h3>
            </div>

            <form className="card shadow-lg p-4 rounded-3 border-0">
              <div className="mb-4">
                <label
                  htmlFor="position"
                  className="form-label fw-bold text-primary"
                  style={{ fontFamily: 'Work Sans, Lora, Merriweather' }}
                >
                  Target Position
                </label>
                <input
                  value={position}
                  onChange={(e) => {
                    setPosition(e.target.value);
                  }}
                  type="text"
                  className="form-control form-control-lg rounded-pill"
                  id="position"
                  placeholder="e.g., Senior Product Manager"
                />
              </div>

              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <label
                    htmlFor="industry"
                    className="form-label fw-bold text-primary"
                    style={{ fontFamily: 'Work Sans, Lora, Merriweather' }}
                  >
                    Industry
                  </label>
                  <input
                    value={industry}
                    onChange={(e) => {
                      setIndustry(e.target.value);
                    }}
                    type="text"
                    className="form-control rounded-3"
                    id="industry"
                    placeholder="e.g., Tech, Healthcare, Finance"
                  />
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="experience"
                    className="form-label fw-bold text-primary"
                    style={{ fontFamily: 'Work Sans, Lora, Merriweather' }}
                  >
                    Years of Experience
                  </label>
                  <input
                    value={experience}
                    onChange={(e) => {
                      setExperience(e.target.value);
                    }}
                    type="number"
                    className="form-control rounded-3"
                    id="experience"
                    placeholder="Enter years"
                    min="0"
                  />
                </div>
                <div>
                  <button type="submit" onClick={handleOnClick} className="generate-resume-button">
                    <i className="bi bi-magic me-2"></i>
                    Generate Smart Resume
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Backdrop open={loader}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
      </Backdrop>
    </>
  );
};

export default AI_Add_Resume;
